// AI ESG Advisor (rule-based mock). Produces 5 recommendations using
// baseline/optimized totals, supplier scoring, benchmarks and compliance score.

export type AdvisorInput = {
  baselineTotalKg: number;
  optimizedTotalKg: number;
  supplierScore: number; // 0..100
  industryAvgKgPerEmployee: number;
  regionEnergyKgPerKWh: number;
  complianceScore: number; // 0..100
};

export type Recommendation = {
  actionTitle: string;
  estimated_co2_saved: number;
  estimated_cost_savings: number;
  difficulty: 1 | 2 | 3 | 4 | 5;
  time_to_impact: 'short' | 'medium' | 'long';
  taxonomy_align: boolean;
};

export function generateRecommendations(i: AdvisorInput): Recommendation[] {
  const saved = Math.max(0, i.baselineTotalKg - i.optimizedTotalKg);
  const energyAction: Recommendation = {
    actionTitle: 'Increase LED adoption by 20%',
    estimated_co2_saved: Math.max(100, saved * 0.15),
    estimated_cost_savings: Math.max(200, saved * 0.15 * 0.23),
    difficulty: 2,
    time_to_impact: 'short',
    taxonomy_align: true
  };

  const remoteAction: Recommendation = {
    actionTitle: 'Expand remote policy to 3 days/week',
    estimated_co2_saved: Math.max(100, saved * 0.12),
    estimated_cost_savings: Math.max(150, saved * 0.12 * 0.23),
    difficulty: 3,
    time_to_impact: 'medium',
    taxonomy_align: true
  };

  const supplierAction: Recommendation = {
    actionTitle: 'Re-score suppliers and switch top 10% to greener alternatives',
    estimated_co2_saved: Math.max(50, (100 - i.supplierScore) * 10),
    estimated_cost_savings: 0,
    difficulty: 4,
    time_to_impact: 'medium',
    taxonomy_align: true
  };

  const energyMarketAction: Recommendation = {
    actionTitle: 'Switch to renewable energy contract',
    estimated_co2_saved: Math.max(100, i.regionEnergyKgPerKWh * 10000 * 0.6),
    estimated_cost_savings: 0,
    difficulty: 3,
    time_to_impact: 'short',
    taxonomy_align: true
  };

  const complianceAction: Recommendation = {
    actionTitle: 'Close compliance gaps to boost score by +10',
    estimated_co2_saved: Math.max(50, i.complianceScore * 5),
    estimated_cost_savings: 0,
    difficulty: 2,
    time_to_impact: 'long',
    taxonomy_align: true
  };

  return [energyAction, remoteAction, supplierAction, energyMarketAction, complianceAction];
}



















